import styled from "styled-components";
export var PageTitle = /*#__PURE__*/ styled.h1.withConfig({
  displayName: "Typography__PageTitle"
})(["", ""], props => props.theme.typography.pageTitle);
export var Subtitle = /*#__PURE__*/ styled.h2.withConfig({
  displayName: "Typography__Subtitle"
})(["", ""], props => props.theme.typography.subtitle);
export var SectionTitle = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__SectionTitle"
})(["", ""], props => props.theme.typography.sectionTitle);
export var ButtonText = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__ButtonText"
})(["", ""], props => props.theme.typography.buttonText);
export var BodyHighlight = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__BodyHighlight"
})(["", ""], props => props.theme.typography.bodyHighlight);
export var Body = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__Body"
})(["", ""], props => props.theme.typography.body);
export var DescriptionMedium = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__DescriptionMedium"
})(["", ""], props => props.theme.typography.descriptionMedium);
export var Description = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__Description"
})(["", ""], props => props.theme.typography.description);
export var LabelMedium = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__LabelMedium"
})(["", ""], props => props.theme.typography.labelMedium);
export var Label = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__Label"
})(["", ""], props => props.theme.typography.label);
export var NotificationsNumbers = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Typography__NotificationsNumbers"
})(["", ""], props => props.theme.typography.notificationsNumbers);
